import React from "react";
import styled from "styled-components";
import LegacyIcon from "components/icons/legacy-icon";

const ErrorContent = styled.p`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
`;

const ErrorInnerContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ErrorOuterContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  padding: 2rem 0;
  width: 100%;
`;

const ErrorTitle = styled.h3`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
`;

function ServerError() {
  return (
    <ErrorOuterContainer>
      <ErrorInnerContainer>
        <LegacyIcon name="server-error-90" />
        <ErrorTitle>Server Error</ErrorTitle>
        <ErrorContent>
          Something went wrong. <br />
          Please reload the page.
        </ErrorContent>
      </ErrorInnerContainer>
    </ErrorOuterContainer>
  );
}

export default ServerError;
